import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private translate = inject(TranslateService);

  private readonly STORAGE_KEY = 'language';

  initialize(): void {
    this.translate.addLangs(['pt-BR', 'en-US', 'es-ES']);
    this.translate.setDefaultLang('pt-BR');
    const savedLanguage = localStorage.getItem(this.STORAGE_KEY);
    this.translate.use(savedLanguage || 'pt-BR');
  }

  setLanguage(language: string): void {
    this.translate.use(language);
    localStorage.setItem(this.STORAGE_KEY, language);
  }

  getLanguage(): string {
    return localStorage.getItem(this.STORAGE_KEY) || 'pt-BR';
  }
}
